import { QUERY_KEYS } from "../../../constants/queryKeys";
import { useQuery } from "../../../reactQuery";
import { CasProfileApi } from "../../../services";

export const useGetProfile = () => {
  const casProfileApi = CasProfileApi.init();

  return useQuery(QUERY_KEYS.profile, () => casProfileApi.getProfile(), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
